import script from "./CallInDashBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./CallInDashBoard.vue?vue&type=script&setup=true&lang=js"

import "./CallInDashBoard.vue?vue&type=style&index=0&id=314a498c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-314a498c"]])

export default __exports__